import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';

import {context, mesAutobind} from '@posco/posco-shared';
import {Button, dialog, message, Modal, notification} from '@posco/posco-ui-react';
import moment from 'moment';
import StringUtil from '../custom/StringUtil'
import O10g015350 from "../view/O10g015350";
/*다국어 적용을 위한 whitTranslation import*/
import {withTranslation} from 'react-i18next'
@inject('o10g015460Store')
@mesAutobind
@observer
class O10g015350Container extends Component {

  /**회원가입(외부공급사 권한 신청 팝업)**/

  state = {
    agree1: false,
    securityAgree: false,
    period: [moment().add(1, 'days').format('YYYY-MM-DD'), moment().add(1, 'year').format('YYYY-MM-DD')],
    periodDV: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    isFamily: false,
    open : false
  };

  changeHandle(_state) {
    this.setState(_state);
  }

  handleCancel() {
    this.goList();
    // Popout.close();
  }

  /**모달 닫기**/
  onClose() {
    // this.props.o10g015460Store.changeDisabled(true);
    console.log("모달 닫힘!!!");
    this.props.close();
  }

  async handleSave() {
    const createData = {
      vendorId: document.getElementById('vendorId').value,
      vendorName: document.getElementById('vendorName').value,
      subcNm: document.getElementById('subcNm').value,
      vendorPhone: document.getElementById('phone').value,
      webUserEmail: document.getElementById('email').value,
      name: document.getElementById('projectName').value,
      commonBusinessReqReason: document.getElementById('reason').value,
      smrtNoteUserId: (this.state.isFamily ? '' : 'sup-') + document.getElementById('userId').value,
      dateFrom: this.state.period[0] + ' 00:00:00',
      dateTo: this.state.period[1] + ' 23:59:59',
      chargeEmpNum: document.getElementById('chargeEmpNum').value, //피엠
      manPrcStexExpl1: this.state.agree1,
      manPrcStexExpl2: this.state.agree1,
      manPrcStexExpl3: this.state.securityAgree
    };

    console.log("createData::::", createData);
    console.log("moment(this.state.period[0]).isBefore(moment())::", moment(this.state.period[0]).isBefore(moment()));

    const ID={
      id: createData.smrtNoteUserId
    };

    const EMAIL={
      email: createData.webUserEmail
    };

    /**(그룹사) 포스코건설 689 , 포스코ICT 1149 , 포스코플랜텍 592는 제외 */
    if(createData.vendorId === "592" ||  createData.vendorId === "689" ||  createData.vendorId === "1149") {
      if (!createData.name || !createData.commonBusinessReqReason
        || !createData.smrtNoteUserId || !this.state.period[0] || !createData.chargeEmpNum){
        await dialog.alert(message(this.translate.O10G015350_MW_00001)); //모든 값은 필수입니다.
        return;
      }
    }
    else {
      if (!createData.vendorId || !createData.subcNm || !createData.vendorPhone
        || !createData.webUserEmail || !createData.name || !createData.commonBusinessReqReason
        || !createData.smrtNoteUserId || !this.state.period[0] || !createData.chargeEmpNum) {
        await dialog.alert(message(this.translate.O10G015350_MW_00001)); //모든 값은 필수입니다.
        return;
      }
      if (createData.webUserEmail.length > 50 || !StringUtil.checkEmail(createData.webUserEmail)) {
        //메일 포멧이 맞지 않습니다.
        await dialog.alert(message(this.translate.O10G015350_MW_00002));
        return;
      }
      if (!StringUtil.checkOnlyEngAndNum(document.getElementById('userId').value)) {
        console.log("document.getElementById('userId').value", document.getElementById('userId').value);
        // ID는 영문 소문자, 숫자만 입력 가능합니다.
        await dialog.alert(message(this.translate.O10G015350_MW_00003));
        return;
      }


    }

    /**(그룹사) 포스코건설 689 , 포스코ICT 1149 , 포스코플랜텍 592는 제외 */
    if(createData.webUserEmail &&
      !(createData.vendorId === "592" ||  createData.vendorId === "689" ||  createData.vendorId === "1149")
    ){
      const result = await this.props.o10g015460Store.onDuplicateEmail(EMAIL);
      console.log("EMAIL 컨테이너 result::::", result);
      console.log("createData.vendorId::::", createData.vendorId);
      if (result && result > 0) {
        // 이미 사용중인 e-mail입니다.
        await dialog.alert(message(this.translate.O10G015350_MW_00004));
        return;
      }
    }
    if (moment(this.state.period[0]).isBefore(moment())) {
      // 금일 이후 날짜를 지정해주시기 바랍니다.
      await dialog.alert(message(this.translate.O10G015350_MW_00005));

      return;
    }


    /**(그룹사) 포스코건설 689 , 포스코ICT 1149 , 포스코플랜텍 592는 신청서에서만 ID확인 */
    if(createData.smrtNoteUserId &&
      (createData.vendorId === "592" ||  createData.vendorId === "689" ||  createData.vendorId === "1149")){
      const result = await this.props.o10g015460Store.onDupFamilyId(ID);
      console.log("컨테이너 result::::", result);
      if (result && result > 0) {
        // 이미 사용중인 ID입니다.
        await dialog.alert(message(this.translate.O10G015350_MW_00008));
        return;
      }
    } else {
      const result = await this.props.o10g015460Store.onDuplicateId(ID);
      console.log("컨테이너 result::::", result);
      if (result && result > 0) {
        // 이미 사용중인 ID입니다.
        await dialog.alert(message(this.translate.O10G015350_MW_00008));
        return;
      }
    }

    if (!createData.manPrcStexExpl1) {
      //투자관리시스템 개인정보 수집 및 이용에 동의는 필수 입니다.
      await dialog.alert(message(this.translate.O10G015350_MW_00006));
      return;
    }
    if (!createData.manPrcStexExpl3) {
      // 투자관리시스템 보안서약서 동의는 필수 입니다.
      await dialog.alert(message(this.translate.O10G015350_MW_00007));
      return;
    }

    //권한 신청을 하시겠습니까?
    const confirmed =  await dialog.confirm(message(this.translate.O10G015350_MV_00001));
    if(confirmed){
      await this.props.o10g015460Store.saveExternalUserAuthority(createData);
      await this.onClose();
      // const msgNoti = "신청되었습니다";
      notification(message(this.translate.O10G015350_MW_00009));
    }

  }

  /*props로부터 다국어 표현을 위한 t함수 획득*/
  get translate() {
    const {t} = this.props;
    return ({

      O10_LB_00002: t('O10_LB_00002', {ns:'common'}), // 추가
      O10_LB_00003: t('O10_LB_00003', {ns:'common'}), // 수정
      O10_LB_00004: t('O10_LB_00004', {ns:'common'}), // 삭제
      O10_LB_00005: t('O10_LB_00005', {ns:'common'}), // 저장

      O10_MC_00001: t('O10_MC_00001', {ns:'common'}), //저장되었습니다."
      O10_MC_00002: t('O10_MC_00002', {ns:'common'}), //수정되었습니다."
      O10_MC_00003: t('O10_MC_00003', {ns:'common'}), //삭제되었습니다."
      O10_MC_00004: t('O10_MC_00004', {ns:'common'}), //조회되었습니다."
      O10_MC_00005: t('O10_MC_00005', {ns:'common'}), //등록되었습니다."
      O10_MC_00006: t('O10_MC_00006', {ns:'common'}), //생성되었습니다."
      O10_MC_00021: t('O10_MC_00021', {ns:'common'}), //조회된 데이터가 없습니다
      O10_MC_00022: t('O10_MC_00022', {ns:'common'}), //처리가 완료되었습니다"
      O10_MC_00023: t('O10_MC_00023', {ns:'common'}), //확정되었습니다."
      O10_MC_00024: t('O10_MC_00024', {ns:'common'}), //취소되었습니다."
      O10_MC_00025: t('O10_MC_00025', {ns:'common'}), //취소되었습니다."
      O10_ME_00001: t('O10_ME_00001', {ns:'common'}), //저장 실패하였습니다."

      O10_MV_00001: t('O10_MV_00001', {ns: 'common'}),//저장하시겠습니까?",
      O10_MV_00002: t('O10_MV_00002', {ns: 'common'}),//수정하시겠습니까?",
      O10_MV_00003: t('O10_MV_00003', {ns: 'common'}),//삭제하시겠습니까?",
      O10_MV_00004: t('O10_MV_00004', {ns: 'common'}),//조회하시겠습니까?",
      O10_MV_00005: t('O10_MV_00005', {ns: 'common'}),//등록하시겠습니까?",
      O10_MV_00006: t('O10_MV_00006', {ns: 'common'}),//확정하시겠습니까?",
      O10_MV_00007: t('O10_MV_00007', {ns: 'common'}),//확정취소하시겠습니까?",
      O10_MV_00008: t('O10_MV_00008', {ns: 'common'}),//신규입력을 하시겠습니까?"
      O10_MV_00009: t('O10_MV_00009', {ns: 'common'}),//변경사항을 저장하시겠습니까?"
      O10_MV_00010: t('O10_MV_00010', {ns: 'common'}),//선택된 데이터를 삭제하시겠습니까?
      O10_MV_00011: t('O10_MV_00011', {ns: 'common'}),//승인하시겠습니까?",
      O10_MV_00012: t('O10_MV_00012', {ns: 'common'}),//반려하시겠습니까?",
      O10_MV_00013: t('O10_MV_00013', {ns: 'common'}),//전송하시겠습니까?"


      O11_LB_00007: t('O11_LB_00007', {ns: 'common'}),//취소


      O10G015350_MW_00001: t('O10G015350_MW_00001', {ns:'service'}), //모든 값은 필수입니다.",
      O10G015350_MW_00002: t('O10G015350_MW_00002', {ns:'service'}), //메일 포멧이 맞지 않습니다."
      O10G015350_MW_00003: t('O10G015350_MW_00003', {ns:'service'}), //ID는 영문 소문자, 숫자만 입력 가능합니다
      O10G015350_MW_00004: t('O10G015350_MW_00004', {ns:'service'}), //이미 사용중인 e-mail입니다.
      O10G015350_MW_00005: t('O10G015350_MW_00005', {ns:'service'}), //금일 이후 날짜를 지정해주시기 바랍니다.
      O10G015350_MW_00006: t('O10G015350_MW_00006', {ns:'service'}), //투자관리시스템 개인정보 수집 및 이용에 동의는 입니다
      O10G015350_MW_00007: t('O10G015350_MW_00007', {ns:'service'}), //투자관리시스템 보안서약서 동의는 필수 입니다.
      O10G015350_MW_00008: t('O10G015350_MW_00008', {ns:'service'}), //이미 사용중인 ID입니다.
      O10G015350_MW_00009: t('O10G015350_MW_00009', {ns:'service'}), //신청되었습니다.

      O10G015350_MV_00001: t('O10G015350_MV_00001', {ns:'service'}), //권한 신청을 하시겠습니까?

      O10G015350_LV_00001: t('O10G015350_LV_00001', {ns:'service'}), //신청



    });
  }

  render() {
    return (

      <Modal
        open={this.props.openSignUp}  onClose={this.onClose} size={this.props.size || 'large'} draggable>
        <Modal.Header content="외부사용자 권한신청"/>
        <Modal.Content>
          <section className="o10g015350">
            <div style={{
              height: '640px',
              overflow: 'auto'
            }}>
              <O10g015350
                changeHandle={this.changeHandle}
                isFamily={this.state.isFamily}
                // 개인정보처리방침
                user030s={this.props.o10g015460Store.user030s}
              />
            </div>
            <hr/>
            <div className="btnWrapC">
              {/*신청*/}
              <Button onClick={this.handleSave} className="btnSearch mgr-8">{this.translate.O10G015350_LV_00001}</Button>
              {/*취소*/}
              <Button onClick={this.onClose} className="btn1st">{this.translate.O11_LB_00007}</Button>
            </div>
          </section>
        </Modal.Content>
      </Modal>
    );
  }
}

/* Translation 사용을 위해 HOC(Higher order component) 사용*/
export default withTranslation()(O10g015350Container);
